<div class="audit-logs-container">
    <div class="header-section mb-3">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">
                <i class="fa-solid fa-clipboard-list me-2"></i>
                Audit Logs
            </h3>
            <div class="header-actions">
                <button class="btn btn-outline-primary me-2" (click)="toggleCard()">
                    <i class="fa-solid fa-filter me-1"></i>
                    Filtre
                </button>
                <button class="btn btn-success" (click)="exportCsv()" [disabled]="isExporting">
                    <mat-spinner diameter="18" *ngIf="isExporting" class="me-1"></mat-spinner>
                    <i class="fa-solid fa-download me-1" *ngIf="!isExporting"></i>
                    Export CSV
                </button>
            </div>
        </div>
    </div>

    <!-- Filters Card -->
    <div class="filters-card mb-3" *ngIf="showCard">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-label">Data de la</label>
                        <input type="date" class="form-control" [(ngModel)]="dateFrom">
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Data pana la</label>
                        <input type="date" class="form-control" [(ngModel)]="dateTo">
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Actiune</label>
                        <select class="form-select" [(ngModel)]="actionFilter">
                            <option value="">Toate</option>
                            <option *ngFor="let action of actions" [value]="action.value">{{ action.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Certificat</label>
                        <input type="text" class="form-control" [(ngModel)]="certificateFilter"
                            placeholder="Slug certificat">
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <label class="form-label">Cautare</label>
                        <input type="text" class="form-control" [(ngModel)]="searchFilter"
                            placeholder="Cauta dupa request ID, user...">
                    </div>
                    <div class="col-md-6 d-flex align-items-end justify-content-end">
                        <button class="btn btn-secondary me-2" (click)="resetForm()">
                            <i class="fa-solid fa-times me-1"></i>
                            Reseteaza
                        </button>
                        <button class="btn btn-primary" (click)="applyFilters()">
                            <i class="fa-solid fa-search me-1"></i>
                            Aplica
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- DataTable -->
    <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
            class="table table-striped table-bordered w-100">
        </table>
    </div>

    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>